import styled from "styled-components";
import { LiveCasinoFilterButtonsDefaultBox } from "./live-casino-filter-buttons.default.box";

export const LiveCasinoFilterButtonsCasinoSICisBox = styled(LiveCasinoFilterButtonsDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        border-left: none;
        border-right: none;
    }
`;